import jquery from 'jquery';
import $ from 'jquery';
import gsap from 'gsap';

import Slideshow from './slideshow';

import store from '../base/store';
import { btnFade } from './utils';
import { hamburgers } from './hamburger-array';

class Page {
    constructor(opts) {
        this.refer = opts.refer;
        this.swiper = opts.slider;

        this.slideshow = new Slideshow();

        this.animazioneInCorso = false;
        this.docWidth = window.innerWidth;
        this.$delayati = $('.delay_1');
        this.$edited = null;
        this.tlTextAnV = null;


        this.$textImageClick = $('.text-img');
        this.$lineImageClick = $('.linea-number-img');
        this.$contNumbeClick = $('.cont-number');
        this.$numberImgClick = $('.number-img');
        this.$swiperPagination = $('.slide-bar');
        this.tlHideElem = null;

        this.tlClickZoom = null;

        this.tlMenuLater = null;
        this.currentId = null;

        this.masterTimeline = null;
    }

    init() {

    const docWidth = this.docWidth;

        $('.cont_burger').each(function() {
            let $cont = $(this),                                //contenitore di ogni burger
            $contParent = $cont.parents('.swiper-slide'),       //swiper contenitore
            $mask = $cont.children('.mask_img'),                //seleziono la maschera del contenitore
            $imageBurger = $mask.children('.img_burger'),       //seleziono l'immagine del contenitore

            slideWidth = $contParent.width(),                   //dimensioni slide
            marginSlideLeft = (docWidth - slideWidth) / 2,      //malcolo la distanza dal left della slide

            contPosition = $cont.position(),                    //trovo la posizione del contenitore
            contOffsetLeft = contPosition.left,                 //distanza dal left del contenitore dalla slide
            top = - contPosition.top,                           //distanza dal top del contenitore dalla slide
            left =  marginSlideLeft + contOffsetLeft;

            gsap.set($imageBurger, {
                top: top,
                left: -left
            });
        });

        this.bindEvents();

    }


    bindEvents() {

        $('#zoom-btn').off('click').on('click', () => {
            this.openSlideshow();
        });

        $('#cont-close-single-img').off('click').on('click', () => {
            this.slideshow.closeSlideshow(this.tlMenuLater);

        });

    }

    expandMask( $cont, id ) {

        this.refer.bindEventPage();
        this.slideshow.animationButtonZoom();

        this.currentId = id;

        if (this.animazioneInCorso) {
            return;
        }
        this.animazioneInCorso = true;
        this.$delayati.removeClass('delay_1');

        const $eleNoClick = $('.cont_burger').not($cont);
        const $mask = $cont.children('.mask_img');
        const $img = $mask.children('.img_burger');

        const slideWidth = $('.swiper-slide-active').width();
        const marginSlideLeft = ( this.docWidth - slideWidth ) / 2;
        const marginCalcLeft = -( marginSlideLeft + $mask.position().left );

        //prima animazione del click
        this.tlHideElem = new TimelineMax({ paused: true });

        TweenMax.to( $eleNoClick, 0.5, {
            opacity: 0,
            ease: Power3.easeInOut
        });

        this.tlHideElem.to(this.$lineImageClick, 0.5, {
            opacity: 0,
            ease: Power3.easeInOut
        }).to(this.$contNumbeClick, 0.5, {
            opacity: 0,
            ease: Power3.easeInOut
        }, 0.1).to(this.$numberImgClick, 0.5, {
            opacity: 0,
            ease: Power3.easeInOut
        }, 0.1).to(this.$textImageClick, 0.5, {
            opacity: 0,
            ease: Power3.easeInOut
        }, 0.1).to(this.$swiperPagination, 0.3, {
            bottom: '-5px',
            ease: Power3.easeInOut
        }, 0.4);

        this.tlHideElem.play();
        //Animazione di zoom dell'immagine
        this.tlClickZoom = new TimelineMax({ paused: true });

        this.tlClickZoom.to($cont, 0.9, {
            top: 0,
            left: marginCalcLeft,
            width: '100vw',
            height: '100vh',
            zIndex: 100,
            ease: Power3.easeInOut
        }, 0.3).to($img, 0.9, {
            top: 0,
            left: 0,
            ease: Power3.easeInOut
        }, 0.3);

        this.tlClickZoom.play();

        setTimeout(() => {
            btnFade( '#zoom-btn', 'in' );
        }, 1000);

        //creazione e sovrapposizione dell'immagine
        let $imgToAppend = $('<div class="img-burger-appesa img-burger-top img-darimuovere"></div>');
        $('body').append( $imgToAppend );

        let $imageBur = $img.css( 'background-image' );
        setTimeout(() => {
            $imgToAppend.css({
                backgroundImage: $imageBur,
                width: '100vw'
            });

            this.tlClickZoom.reverse();

            TweenMax.to( $eleNoClick, 0.5, {
                opacity: 1,
                ease: Power3.easeInOut
            });
            TweenMax.to( $cont, 0.5, {
                opacity: 1,
                ease: Power3.easeInOut
            });
            TweenMax.to('.black-cover-img', 1.1, {
                left: 0,
                ease: Power3.easeInOut,
                delay: 0.4
            });
        }, 1000);

        //timeline apertura pagina specifiche hamburger
        const $textBurger = $('#text-burger');
        const $lateralMenu = $('#lateral-menu');
        this.tlMenuLater = new TimelineMax({ paused: true });

        this.tlMenuLater.add('startTlLat')
        .to($lateralMenu, 0.8, {
            right: 0,
            ease: Power3.easeInOut,
            onComplete: () => {
            }
        }).to($textBurger, 1, {
            right: 0,
            ease: Power3.easeInOut,
            onComplete: () => {
                TweenMax.to('.line-obl-text-burger', 1, {
                    className: '+=line-obl-width',
                    ease: Power3.easeInOut
                });
            }
        }, 'startTlLat');

        setTimeout(() => {
            this.tlMenuLater.play();
        }, 700);

        //Load Pagine interne
        this.$edited = $cont.attr('data-id');
        let $address = `/components/${this.$edited}.html`;

        $('#cont-text-single-burger').load( $address );

        setTimeout(() => {
            TweenMax.staggerTo('.margin-100', 0.6, {
                y: 0,
                opacity: 1,
                ease: Power3.easeInOut,
            }, 0.1);
        }, 1300);

        if(this.$edited < 10)
            $('<p class="number-remove">0' + this.$edited + '</p>').appendTo('.number-change');
        else
            $('<p class="number-remove">' + this.$edited + '</p>').appendTo('.number-change');


    }

    closeMask() {
        this.refer.unbindEventPage();

        TweenMax.set('.black-cover-img', { left: 0 });

        $("#text-burger").animate({ scrollTop: 0 });

        btnFade('#zoom-btn', 'out');

        this.masterTimeline = new TimelineMax({ paused: true })
        this.masterTimeline.add(() =>{
                gsap.to('.img-burger-appesa', 1.6, {
                    left: '100%',
                    ease: Power3.easeInOut,
                    onComplete: () => {
                        $('.img-burger-appesa').remove();
                    }
                });
            }, 0).add(() => {
                this.tlMenuLater.reverse()
            }, 0.35).add(() => {
                TweenMax.to('.black-cover-img--animated', 1.1, {
                    left: '100%',
                    ease: Power3.easeInOut,
                });
            }, 0.9).add(() => {
                $('.number-remove').remove();
                $(".line-obl-text-burger").removeClass("line-obl-width");

                this.tlHideElem.eventCallback('onReverseComplete', () => {
                    this.$delayati.addClass('delay_1');
                    this.animazioneInCorso = false;
                });
                this.tlHideElem.reverse();
            }, 1.25)

        this.masterTimeline.play();

    }

    changePage(currentId, dir) {

        const relativity = dir === 'left' ? 200 : -200;
        const currentIndex = this.currentId = currentId;
        const address = `/components/${currentIndex}.html`;

        // this.refer.unbindEventPage();

        gsap.to('.line-obl-text-burger', 0.6, {
            className: '-=line-obl-width',
            ease: Power3.easeInOut
        });

        $('#text-burger').animate({ scrollTop: 0 });

        //creazione e sovrapposizione dell'immagine
        let $classeDaRimuovere = $('.img-darimuovere');
        let $immagineDaAppendere = $(`<div class="img-burger-appesa img-burger-top img-darimuovere img-daanimare-${dir} background-img-burger"></div>`);
        $('body').append( $immagineDaAppendere );

        gsap.to(`.img-daanimare-${dir}`, 1.6, {
            left: 0,
            ease: Power3.easeInOut,
            onStart: function () {
                gsap.to('.line-obl-text-burger', 1.2, {
                    className: '+=line-obl-width',
                    ease: Power3.easeInOut,
                    delay: 0.6
                });
            },
            onComplete: function () {
                $('.img-burger-appesa').toggleClass(`img-daanimare-${dir} img-animata-${dir}`);
            }
        });

        gsap.to($classeDaRimuovere, 0.8, {
            left: relativity,
            ease: Power3.easeInOut,
            delay: 0.6,
            onComplete: function () {
                $classeDaRimuovere.remove();
            }
        });


        gsap.to('.cont-card-animation', 0.6, {
            opacity: 0,
            ease: Power3.easeInOut,
            onComplete: () => {

                $('#cont-text-single-burger').load(address, () => {

                    const hamburger = hamburgers[ currentIndex ];
                    const urlImgSel = 'url' + '(' + hamburger.immagini[ 0 ] + ')';

                    $('.number-remove').remove();
                    $(`.img-daanimare-${dir}`).css( 'background-image', urlImgSel);

                    if (currentIndex < 10) {
                        $('<p class="number-remove">0' + currentIndex + '</p>').appendTo('.number-change');
                    } else {
                        $('<p class="number-remove">' + currentIndex + '</p>').appendTo('.number-change');
                    };

                    gsap.staggerTo(('.margin-100'), 0.6, {
                        y: 0,
                        opacity: 1,
                        delay: 0.45,
                        ease: Power3.easeInOut,
                     }, 0.1, () => {
                        store.isAnimating = false;
                    });

                });
            },
        }, 0.1);

    }

    openSlideshow() {

        let currentIndex = this.currentId;

        btnFade('#zoom-btn', 'out');
        btnFade('#about-btn', 'out');

        this.slideshow.init(currentIndex);
        this.slideshow.openSlideshow();

        this.tlMenuLater.reverse();

    }

}

export default Page;



/** WEBPACK FOOTER **
 ** ./components/page.js
 **/